import strings from "../_constants/strings";

const userRegex = /^\S*$/;
const regex = new RegExp(
    // /^[^-\s][a-zA-Z0-9!@#$*_-][^,&%;'π₡¢€:÷=`×{}£<>\\//+¶○°¥€?~|"["()\]]+$/
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
);
const emojiRegex = new RegExp(
    `(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])`
);

export const validatePassword = (password, minLength = 7, maxLength = 15) => {
    if (password.length < 8) {
        return "Minimum length allowed is 8.";
    } else if (!regex.test(password) && !emojiRegex.test(password)) {
        return "Should be 8 characters, 1 alphabet upper case, 1 number, and 1 special character";
    }
    return false;
};

export const validateUsername = (username) => {
    const { LABELS: { USER_ID } } = strings;
    if (!userRegex.test(username)) {
        return `Please enter valid ${USER_ID}`;
    }
    return false;
};